/**
 * @param markup {string}
 * @return {HTMLElement}
 */
module.exports = function createHTMLElement(markup) {
    const div = window.document.createElement("div");

    div.innerHTML = markup;

    if (div.firstElementChild instanceof HTMLElement) {
        return div.firstElementChild;
    }

    throw new Error("createHTMLElement: Invalid HTML!");
}
